export default "__VITE_ASSET__B8aKUG$3__"